var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCFD1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8012 58.5694C51.3527 63.5921 44.0746 66.66 36.08 66.66C19.1911 66.66 5.5 52.9688 5.5 36.08C5.5 28.0854 8.56785 20.8073 13.5905 15.3588L56.8012 58.5694ZM58.569 56.8017L15.3583 13.591C20.8068 8.56804 28.0851 5.5 36.08 5.5C52.9688 5.5 66.66 19.1911 66.66 36.08C66.66 44.0748 63.5919 51.3531 58.569 56.8017ZM69.16 36.08C69.16 54.3495 54.3495 69.16 36.08 69.16C17.8104 69.16 3 54.3495 3 36.08C3 17.8104 17.8104 3 36.08 3C54.3495 3 69.16 17.8104 69.16 36.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoUse);
export default __webpack_public_path__ + "static/media/icon-no-use.5c6f8d53903fd08b2aaff72f835fb8b2.svg";
export { ForwardRef as ReactComponent };